import React from "react";

function SetContractOption({ onClose }) {
  const setModel = (model) => {
    const data = { model: model };
    onClose(data);
  };

  return (
    <>
      <div className="modal fade show" tabIndex="-1">
        <div
          className="modal-dialog modal-dialog-centered text-center"
          role="document"
        >
          <div className="modal-content modal-content-demo">
            <div className="modal-header">
              <h4 className="modal-title">
                Select Any Option To Create Contract
              </h4>
              <button onClick={onClose} className="btn-close"></button>
            </div>
            <div className="modal-body text-start">
              <div className="row text-center">
                <div className="col-md-6 ms-auto">
                  <a
                    onClick={() => setModel("manually")}
                    href="javascript:void(0);"
                    className="btn btn-primary"
                  >
                    <i className="fa-solid fa-file-contract fs-16 me-1"></i>
                    Create & Download Contract
                  </a>
                </div>
                <div className="col-md-6 ms-auto">
                  <a
                    href="javascript:void(0);"
                    onClick={() => setModel("upload")}
                    className="btn btn-primary"
                  >
                    <i className="fa-solid fa-file-arrow-up fs-16 me-1"></i>
                    Upload Contract File
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SetContractOption;
